import * as searchForm from '../components/searchForm';
import * as offersPagination from '../components/offersPagination';

const components = [
	searchForm,
	offersPagination,
];

components.forEach(component => component.init());
